<template>
	<div class="event-action">
		<div class="overlay" @click="$emit('close')"></div>

		<div class="content">
			<div class="pad-l">
				<div class="event-info">
					<div class="date">
						<div class="giorno">{{ $moment(event.start.dateTime).locale('it').format('ddd') }}</div>
						<div class="day">{{ $moment(event.start.dateTime).format('DD') }}</div>
						<div class="month">{{ $moment(event.start.dateTime).locale('it').format('MMM') }}</div>
					</div>
					<div>
						<div class="name">{{ event.summary }}</div>
						<div class="time">
							<span class="far fa-clock" style="margin-right: 0.2em"></span>
							<span>{{ $moment(event.start.dateTime).format('HH:mm') }}</span>
						</div>
					</div>
				</div>

				<div class="event-description" v-if="event.description">
					<span class="fas fa-quote-left quote-left"></span>
					<span>{{ event.description }}</span>
					<span class="fas fa-quote-right quote-right"></span>
				</div>

				<div class="actions">
					<div class="enroll dropped" v-if="event.bDropped">
						<button @click="$emit('enroll')">Prenotati</button>
					</div>
					<div class="drop-out" v-else-if="event.bSub">
						<button @click="$emit('dropout')">Elimina prenotazione</button>
					</div>
					<div class="enroll" v-else>
						<button @click="$emit('enroll')">Prenotati</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/it'

export default {
	name: 'event-action',
	props: {
		event: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			moment // lo rende disponibile nel template
		}
	}
}
</script>

<style lang="stylus" scoped>
fill()
	width 100%
	height 100%

	top 0
	left 0

.event-action
	fill()

	position fixed
	z-index 10000

	pointer-events none

	.overlay
		fill()

		position absolute
		z-index 1

		background-color rgba(light, 0.4)

		pointer-events auto
		cursor pointer
	
	.content
		max-width 600px

		position absolute
		top 50%
		left 50%
		z-index 2

		background-color dark

		pointer-events auto

		transform translate(-50%, -50%)

		@media (max-width: unit(media-phone-max, px))
			width calc(100% - 1em)

		.event-info
			display flex
			align-items center
			
			.date
				padding-right 1.6em
				margin-right 1.6em
				border-right 2px solid primary
				
				text-align center

				.day
					color primary

					font-size 2.4em
					font-weight bold
				
				.month
					font-weight bold

					text-transform uppercase
				
				.giorno
					font-weight bold

					text-transform uppercase
			
			.name
				color secondary

				font-size 1.8em
				font-weight bold
		
		.event-description
			min-height 3em

			position relative

			padding 0.6em
			margin-top 2em

			font-family fontHand
			font-size 1.3em

			.quote-right
			.quote-left
				position absolute
				z-index -1

				color darkish

				font-size 3em
			
			.quote-left
				top 0
				left 0

			.quote-right
				bottom 0
				right 0
		
		.actions
			margin-top 1em

			.drop-out
			.enroll
				>button
					width 100%

					display block

					border none
					padding 0.6em 0.8em

					opacity 0.9

					font-family fontSans
					font-size 1.2em
					font-weight bold

					text-transform uppercase

					cursor pointer

					transition 0.15s ease

					&:focus
						outline none
					&:hover
						opacity 1
			
			.drop-out>button
				background-color indianred
				color light
			
			.enroll>button
				background-color primary
				color dark
			
			.enroll.dropped>button
				background-color coral
</style>